import React from 'react';
import { Outlet } from 'react-router-dom';
import MainNavbar from '../MainNavbar/MainNavbar';
import Footer from '../Footer/Footer';
import Breadcrumb from '../Breadcrumb/Breadcrumb';
import { useBreadcrumb } from '../../contexts/BreadcrumbContext';
import styles from './Layout.module.css';
import { Container, Paper } from '@mui/material';

interface LayoutProps {
  children?: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { breadcrumbs } = useBreadcrumb();

  return (
    <div className={styles.layout}>
      <MainNavbar />
      <main className={styles.content}>
        <Container maxWidth="lg">
          {breadcrumbs.length > 1 && <Breadcrumb items={breadcrumbs} sx={{ mt: 2 }} />}
          <Paper elevation={0} className={styles.paper}>
            <div className={styles.container}>{children || <Outlet />}</div>
          </Paper>
        </Container>
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
